const messageEvent = {
  subscribe: {
    NEW_MESSAGE: 'subscribe.newMessage',
    READ_MESSAGE: 'subscribe.readMessage',
    MARK_MESSAGE: 'subscribe.markMessage',
    UNMARK_MESSAGE: 'subscribe.unMarkMessage',
    DELETE_MESSAGE: 'subscribe.deleteMessage',
    SET_ALL_MESSAGE_READ: 'subscribe.setAllMessageRead'
  }
}

export default messageEvent
